import React from 'react';

import FontDefinition from '../font_definition';

const { $ } = window;

export default class SaveFdDialog extends React.Component {
  constructor(props) {
    super(props);

    let data = {};
    Object.keys(props).forEach(key => data[key] = props[key]);
    this.state = data;
    this.state.fontDefinitions = this.state.toolbar.state.project.fontDefinitions;
    this.state.fontDefinition = this.state.toolbar.state.project.currentFontDefinition.clone();
    this.state.name = this.state.fontDefinition.name;
    this.state.nameExisting = this.state.fontDefinition.name;
  }

  componentWillReceiveProps(props) {
    this.setState(props);
    this.setState({
      fontDefinitions: this.state.toolbar.state.project.fontDefinitions,
      fontDefinition: this.state.toolbar.state.project.currentFontDefinition.clone(),
      name: this.state.toolbar.state.project.currentFontDefinition.name,
      nameExisting: this.state.toolbar.state.project.currentFontDefinition.name
    });
  }

  componentDidMount() {
    $('#save-fd-dialog.ui.modal').modal({
      onHidden: () => this.hide(),
      onApprove: () => this.save()
    });
  }

  componentDidUpdate() {
    $('#save-fd-dialog.ui.modal').modal(this.props.visible ? 'show' : 'hide');
    $('#save-fd-dialog input[type="text"]').focus();
  }

  hide() {
    this.state.toolbar.setState({
      showSaveFdDialog: false
    });
  }

  save() {
    this.state.fontDefinition.name = this.state.name;
    this.state.toolbar.state.project.updateFontDefinition(this.state.name, this.state.fontDefinition, true);
  }

  update(e) {
    let name = e.target.name;
    let value = e.target.value;

    let data = {};
    data[name] = value;

    if (name == 'name') {
      data.nameExisting = this.state.fontDefinitions.find(x => x.name == e.target.name) ? value : '';
    } else if (name == 'nameExisting' && value != '') {
      data.name = value;
    }

    this.setState(data);
  }

  submitForm(e) {
    e.preventDefault();

    this.save();
    this.hide();
  }

  render() {
    let project = this.state.project;

    return (
      <div className="ui modal" id="save-fd-dialog">
        <div className="header">
          Сохранение пресета
        </div>
        <div className="content">
          <form className="ui form" onSubmit={this.submitForm.bind(this)}>
            <div className="field">
              <label>Выберите уже существующий пресет для его обновления:</label>
              <select className="ui fluid dropdown" name="nameExisting" value={this.state.name} onChange={this.update.bind(this)}>
                <option key="" value=""></option>
                {this.state.fontDefinitions.map((fd, index) => (
                  <option key={fd.name} value={fd.name}>{fd.name}</option>
                ))}
              </select>
            </div>
            <div className="field">
              <label>Или введите название для нового:</label>
              <input type="text" name="name" value={this.state.name} onChange={this.update.bind(this)} autoComplete="off" />
            </div>
          </form>
        </div>
        <div className="actions">
          <button className="ui right primary approve button">Ок</button>
          <button className="ui right cancel button">Отмена</button>
        </div>
      </div>
    );
  }
}
